import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useIsAuthenticated } from '../helpers/useAuthentication';

const ProtectedRoute = ({
  component: Component,
  path,
  ...rest
}: {
  component: React.ComponentType;
  path: string;
}) => {
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();
  return (
    <Route
      {...rest}
      render={() =>
        isAuthenticated ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: '/signIn',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default ProtectedRoute;
